<template>
  <div class="adjuster">
    <div class="cancan pos-rel">
      <canvas @mousedown="info.md = true" @mouseup="info.md = false" class="cancan" ref="cancan" />
      <img @mousedown.prevent="info.md = true" @mouseup="info.md = false"  class="cancan pos-abs" src="./img/filter.png" ref="frame" />
      <!-- <img class="cancan frame" src="./img/frame.png" ref="frame" /> -->
    </div>

    <div class="input-row" v-if="!readOnly">
      <img class="logo-1" src="./img/small-logo.svg" />
      <input class="ranger" type="range" min="1" max="100" step="0.00001" value="0" @input="drawLater" v-model="info.scale"  />
      <img class="logo-2" src="./img/large-logo.svg" />
    </div>

    <div class="debug-area" v-show="debug">
      <br />
      <hr>
      debugger
      <br/>offset X<input type="range" min="0" max="1" step="0.00001" value="0" @input="drawLater" v-model="info.offset.x"  />
      <br/>offset Y<input type="range" min="0" max="1" step="0.00001" value="0" @input="drawLater" v-model="info.offset.y"  />
    </div>
  </div>
</template>

<script>
import * as LoadImg from 'blueimp-load-image'
/* eslint-disable */
function drawImageProp(ctx, img, iw, ih, x, y, w, h, offsetX, offsetY, scale) {
  if (arguments.length === 2) {
      x = y = 0;
      w = ctx.canvas.width;
      h = ctx.canvas.height;
  }

  // default offset is center
  offsetX = typeof offsetX === "number" ? offsetX : 0.5;
  offsetY = typeof offsetY === "number" ? offsetY : 0.5;

  // keep bounds [0.0, 1.0]
  if (offsetX < 0) offsetX = 0;
  if (offsetY < 0) offsetY = 0;
  if (offsetX > 1) offsetX = 1;
  if (offsetY > 1) offsetY = 1;

  var iw = iw || img.width,
      ih = ih || img.height,
      r = Math.min(w / iw, h / ih),
      nw = iw * r,   // new prop. width
      nh = ih * r,   // new prop. height
      cx, cy, cw, ch, ar = 1;

  // decide which gap to fill
  if (nw < w) ar = w / nw;
  if (Math.abs(ar - 1) < 1e-14 && nh < h) ar = h / nh;  // updated
  nw *= ar * scale;
  nh *= ar * scale;

  // calc source rectangle
  cw = iw / (nw / w);
  ch = ih / (nh / h);

  cx = (iw - cw) * offsetX;
  cy = (ih - ch) * offsetY;

  // make sure source rectangle is valid
  if (cx < 0) cx = 0;
  if (cy < 0) cy = 0;
  if (cw > iw) cw = iw;
  if (ch > ih) ch = ih;

  // fill image in dest. rectangle
  ctx.drawImage(img, cx, cy, cw, ch,  x, y, w, h);
}
function drawImageScaled (ctx, img) {
  var canvas = ctx.canvas
  var hRatio = canvas.width / img.width
  var vRatio =  canvas.height / img.height
  var ratio  = Math.min(hRatio, vRatio)
  var centerShift_x = (canvas.width - img.width*ratio) / 2
  var centerShift_y = (canvas.height - img.height*ratio) / 2
  ctx.clearRect(0,0,canvas.width, canvas.height)
  ctx.drawImage(img, 0,0, img.width, img.height, centerShift_x,centerShift_y,img.width*ratio, img.height*ratio)
}

/* eslint-enable */

export default {
  props: {
    readOnly: {
      default: false
    },
    debug: {
      default: false
    },
    image: {}
  },
  data () {
    return {
      info: {
        md: false,
        offset: {
          x: 0.5,
          y: 0.5
        },
        scale: 1
      },
      rect: false,
      ctx: false,
      fixed: false
    }
  },
  watch: {
    image () {
      this.load()
    }
  },
  mounted () {
    var canvas = this.$refs['cancan']
    this.ctx = canvas.getContext('2d')

    this.toDataURL = () => {
      return canvas.toDataURL()
    }

    var resizer = () => {
      var rect = canvas.getBoundingClientRect()
      canvas.style.width = rect.width + 'px'
      canvas.style.height = rect.height + 'px'
      canvas.width = rect.width * 2
      canvas.height = rect.height * 2
      this.rect = canvas.getBoundingClientRect()
      this.drawLater()
    }
    resizer()
    window.addEventListener('resize', resizer, false)

    var wheelr = (evt) => {
      if (this.readOnly) { return }
      evt.preventDefault()
      let v = evt.deltaY * 0.1
      if ((this.info.scale + v) >= 0.0 && (v + this.info.scale) <= 100.0) {
        this.info.scale += v
        this.drawLater()
      } else if (this.info.scale < 0.0) {
        this.info.scale = 0
        this.drawLater()
      } else if (this.info.scale > 100) {
        this.info.scale = 100.0
        this.drawLater()
      }
    }

    var mousemover = (evt) => {
      if (!this.info.md || !this.rect) { return }
      let t1 = evt
      let rect = this.rect
      this.info.offset.x = ((t1.pageX - rect.left) / (canvas.width * 0.5)) * 2 - 1
      this.info.offset.y = ((t1.pageY - rect.top) / (canvas.height * 0.5)) * 2 - 1
      console.log(this.info.offset)
      this.drawLater()
    }

    var touchmover = (evt) => {
      var touches = evt.touches
      var t1 = touches[0]
      if (t1 && this.rect) {
        evt.preventDefault()
        let rect = this.rect
        this.info.offset.x = ((t1.pageX - rect.left) / (canvas.width * 0.5)) * 2 - 1
        this.info.offset.y = ((t1.pageY - rect.top) / (canvas.height * 0.5)) * 2 - 1
      }
      this.drawLater()
    }

    let frame = this.$refs['frame']
    frame.addEventListener('mousemove', mousemover, false)
    frame.addEventListener('touchmove', touchmover, false)
    frame.addEventListener('wheel', wheelr, false)

    this.load()
    this.$on('right-orientation-photo', this.drawMe)
  },
  methods: {
    drawLater () {
      this.$nextTick(() => {
        this.drawMe()
      })
    },
    drawMe () {
      var ctx = this.ctx
      var img = this.fixed
      if (!img) {
        return
      }
      var iw = img.width
      var ih = img.height

      var ar = ih / iw

      var x = 0
      var y = 0

      var w = ctx.canvas.width
      var h = ctx.canvas.height

      var offsetX = 0.5 + (0.5 - this.info.offset.x) / 1.0 * ar * 0.5
      var offsetY = 0.5 + (0.5 - this.info.offset.y) / 1.0 * ar * 0.5

      var scale = 1 / ((200 - this.info.scale) / 200)

      drawImageProp(ctx, img, iw, ih, x, y, w, h, offsetX, offsetY, scale)

      // var ctx = this.ctx
      // var img = this.fixed
      // var scale = this.info.scale / 100
      // var ox = this.info.offset.x
      // var oy = this.info.offset.y
      // drawFunz(ctx, img, scale, ox, oy)
    },
    load () {
      LoadImg(this.image, (fixed) => {
        this.fixed = fixed
        this.$emit('right-orientation-photo', fixed)
      }, {
        orientation: true,
        canvas: true,
        crossOrigin: 'Anonymous'
      })
    }
  }
}
</script>

<style scoped>
.cancan{
  width: 200px;
  height: 200px;
  /* border: #CEBC9E solid 1px; */
  box-sizing: border-box;
}
.adjuster{
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  /* height: 100%; */
}
.frame{
  position: absolute;
  top: 0px;
  left: 0px;
}
.frame{
  top: -2px;
  left: -2px;
  width: calc(200px + 2px * 2);
  height: calc(200px + 2px * 2);
}

.pos-rel{
  position: relative;
  border: none;
}
.pos-abs{
  position: absolute;
  top: 0px;
  left: 0px;
}

.input-row{
  width: 250px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.logo-1{
  margin: 10px;
}
.logo-2{
  margin: 10px;
}

input[type=range] {
  -webkit-appearance: none;
  width: 100%;
  margin: 12px 0;
}
input[type=range]:focus {
  outline: none;
}
input[type=range]::-webkit-slider-runnable-track {
  width: 100%;
  height: 1px;
  cursor: pointer;
  box-shadow: 1px 1px 1px rgba(0, 0, 0, 0), 0px 0px 1px rgba(13, 13, 13, 0);
  background: #cebc9e;
  border-radius: 0px;
  border: 0px solid rgba(86, 36, 37, 0);
}
input[type=range]::-webkit-slider-thumb {
  box-shadow: 1px 1px 1px rgba(206, 188, 158, 0.33), 0px 0px 1px rgba(215, 200, 175, 0.33);
  border: 0px solid #000000;
  height: 25px;
  width: 25px;
  border-radius: 25px;
  background: #cebc9e;
  cursor: pointer;
  -webkit-appearance: none;
  margin-top: -12px;
}
input[type=range]:focus::-webkit-slider-runnable-track {
  background: #daccb6;
}
input[type=range]::-moz-range-track {
  width: 100%;
  height: 1px;
  cursor: pointer;
  box-shadow: 1px 1px 1px rgba(0, 0, 0, 0), 0px 0px 1px rgba(13, 13, 13, 0);
  background: #cebc9e;
  border-radius: 0px;
  border: 0px solid rgba(86, 36, 37, 0);
}
input[type=range]::-moz-range-thumb {
  box-shadow: 1px 1px 1px rgba(206, 188, 158, 0.33), 0px 0px 1px rgba(215, 200, 175, 0.33);
  border: 0px solid #000000;
  height: 25px;
  width: 25px;
  border-radius: 25px;
  background: #cebc9e;
  cursor: pointer;
}
input[type=range]::-ms-track {
  width: 100%;
  height: 1px;
  cursor: pointer;
  background: transparent;
  border-color: transparent;
  color: transparent;
}
input[type=range]::-ms-fill-lower {
  background: #c2ac86;
  border: 0px solid rgba(86, 36, 37, 0);
  border-radius: 0px;
  box-shadow: 1px 1px 1px rgba(0, 0, 0, 0), 0px 0px 1px rgba(13, 13, 13, 0);
}
input[type=range]::-ms-fill-upper {
  background: #cebc9e;
  border: 0px solid rgba(86, 36, 37, 0);
  border-radius: 0px;
  box-shadow: 1px 1px 1px rgba(0, 0, 0, 0), 0px 0px 1px rgba(13, 13, 13, 0);
}
input[type=range]::-ms-thumb {
  box-shadow: 1px 1px 1px rgba(206, 188, 158, 0.33), 0px 0px 1px rgba(215, 200, 175, 0.33);
  border: 0px solid #000000;
  height: 25px;
  width: 25px;
  border-radius: 25px;
  background: #cebc9e;
  cursor: pointer;
  height: 1px;
}
input[type=range]:focus::-ms-fill-lower {
  background: #cebc9e;
}
input[type=range]:focus::-ms-fill-upper {
  background: #daccb6;
}

@media screen and (min-width: 374px) {
  .cancan{
    width: 250px;
    height: 250px
  }
  .frame{
    top: -5px;
    left: -5px;
    width: calc(250px + 5px * 2);
    height: calc(250px + 5px * 2);
  }
  .input-row{
    margin-top: 5px;
    width: 250px;
  }
}


@media screen and (min-width: 413px) {
  .cancan{
    width: 270px;
    height: 270px
  }
  .frame{
    top: -4px;
    left: -4px;
    width: calc(270px + 4px * 2);
    height: calc(270px + 4px * 2);
  }
  .input-row{
    margin-top: 10px;
    width: 270px;
  }
}

@media screen and (min-width: 767.77px) {
/* @media screen and (min-width: 1439px) { */
  .cancan{
    width: 390px;
    height: 390px;
  }
  .frame{
    top: -6px;
    left: -6px;
    width: 412px;
    height: 412px;
  }
  .input-row{
    margin-top: 43px;
    width: 308px;
    margin-bottom: 15px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Parts/Adjuster/Adjuster.vue